import React, { Component } from 'react'
import Slider from  'react-slick'
import { ADVERTISEMENT, WEISCHER } from '../constants/itemTypes.jsx'
import { SliderArrowNext, SliderArrowPrev } from '../SliderGeneral/SliderArrows'
import withIsInViewport from '../hooks/withIsInViewport.jsx'
import SliderBasicItemSwitch from './SliderBasicItemSwitch.jsx'
import SliderBasicItemWeischer from './SliderBasicItemWeischer.jsx'
import SliderBasicItemAdvertisement from './SliderBasicItemAdvertisement.jsx'



class Slide extends Component {
    constructor(props) {
        super(props)

        this.state = {
            isMobile: false,
            isJustOneItem: false,
            hasKenBurnsEffect: props.backgroundVisualsSettings.style.includes('KenBurns'),
            kenBurnsToggles: props.items.map(() => false),
            isChanging: false,
            currSlide: 0,
            prevSlide: null
        }

        this.props.settings.nextArrow = <SliderArrowNext />
        this.props.settings.prevArrow = <SliderArrowPrev />

        this.updateDimensions = this.updateDimensions.bind(this)
        this.onBeforeChange = this.onBeforeChange.bind(this)
        this.onAfterChange = this.onAfterChange.bind(this)
    }

    timer;

    componentDidMount() {
        this.updateDimensions()
        window.addEventListener("resize", this.updateDimensions)


        if (this.props.items.length > 1) {
            this.timer = setTimeout(() => {
                this.setState(prev => ({ // start ken burns effect in first slide
                    ...prev,
                    kenBurnsToggles: this.mutateArray(prev.kenBurnsToggles, 0, true)
                }))
            }, 300);
        }
        else this.setState({ isJustOneItem: true });
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.updateDimensions)
        clearTimeout(this.timer);
    }

    updateDimensions() {
        const isMobile = window.innerWidth < 1220

        if(isMobile !== this.state.isMobile) {
            this.setState({
                isMobile: isMobile,
            })
        }
    }

    mutateArray(arr, index, value) {
        const copyArr = [...arr]
        copyArr[index] = value 
        return copyArr
    }
    getSliderSettings() {
        const { settings, scrollToPosition } = this.props
        const { hasKenBurnsEffect, isMobile } = this.state
        // When you change how "fade" is set here, you might have to adjust the code for "sliderFadeClass" in SliderBasic/index.jsx
        if (this.props.backgroundVisualsSettings.trailerAutoplay) {
            return {
                ...settings,
                fade: true,
                dotsClass: "slick-dots " + scrollToPosition,
                speed: isMobile ? 999 : 2222,
                autoplaySpeed: 20000
            }
        }
        else if (hasKenBurnsEffect) {
            return {
                ...settings,
                dotsClass: "slick-dots " + scrollToPosition,
                fade: true,
                speed: isMobile ? 999 : 2222
            }
        }
        else {
            return {
                ...settings,
                dotsClass: "slick-dots " + scrollToPosition
            }
        }
    }

    getFilteredSliderItems() {
        const { items, mainSliderAdvertisementPositioning } = this.props
        const { isMobile } = this.state

        const filteredSliderItems = {
            weischerItems: [],
            advertisementsItems: [],
            sliderItems: [],
            hasSlides: items.length > 0
        }

        if(isMobile) {
            items.map(item => {
                const { type } = item

                if(WEISCHER === type) {
                    filteredSliderItems.weischerItems.push(item)
                } else if(ADVERTISEMENT === type && mainSliderAdvertisementPositioning === 'out_of_slider') {
                    filteredSliderItems.advertisementsItems.push(item)
                } else {
                    filteredSliderItems.sliderItems.push(item)
                }
            })
        } else {
            filteredSliderItems.sliderItems = items
        }

        return filteredSliderItems
    }

    onBeforeChange(oldIndex, newIndex)  {
        const { hasKenBurnsEffect } = this.state

        this.setState({
            isChanging: true
        })

        if(hasKenBurnsEffect) {
            if (!this.state.isJustOneItem)
                this.setState(prev => {
                    return ({
                        ...prev,
                        currSlide: newIndex,
                        prevSlide: oldIndex,
                        kenBurnsToggles:  this.mutateArray(prev.kenBurnsToggles, newIndex, true)
                    })
                })
        } else {
            this.setState({
                currSlide: newIndex,
                prevSlide: oldIndex
            })
        }
    }

    onAfterChange()  {
        const { hasKenBurnsEffect, prevSlide } = this.state

        this.setState({
            isChanging: false
        })

        if(hasKenBurnsEffect) {
            if (!this.state.isJustOneItem)
                this.setState(prev => {
                    return ({
                        ...prev,
                        kenBurnsToggles: this.mutateArray(prev.kenBurnsToggles, prevSlide, false)
                    })
                })
        }
    }

    render() {
        const { 
            refElemViewport,
            moviesData, 
            adsData, 
            advertisementsData,
            canParallax,
            weischerAdsData,
            scrollToPosition, 
            onClickSlideItem,
            sliderTitle,
            backgroundVisualsSettings,
            filterValue,
            filterType,
            showAvailableIn,
            features,
            theme,
            sliderType,
            translation,
            eventOrigins,
            isConnectedFast,
            isInViewport
        } = this.props

        const { currSlide, kenBurnsToggles, isJustOneItem, isMobile, isChanging } = this.state
        const { weischerItems, advertisementsItems, sliderItems, hasSlides } = this.getFilteredSliderItems()
        const settings = this.getSliderSettings()
        const hasLoginHeader = features && features.has_userbar ? ' has-login-header' : ''
        const itemsLength = sliderItems.length
        const hasWeischerItems = weischerItems.length > 0
        let oddSlide = true

        return(
            <div className={'slider-inner-wrapper slider-stripes-wrapper' + (hasSlides ? ''  : ' has-no-slide') + (theme === 'Arthouse' ? ' arthouse-slide' : '')} ref={refElemViewport}>
                {hasSlides && <>
                    {hasWeischerItems ? (
                        weischerItems.map((item, index) => (
                            <SliderBasicItemWeischer
                                key={item.id}
                                index={index}
                                weischerData={weischerAdsData[item.id]}
                                isMobileHero={true}
                                hasLoginHeader={hasLoginHeader}
                            />
                        ))
                    ):(
                        advertisementsItems.map((item, index) => (
                            <SliderBasicItemAdvertisement
                                key={item.id}
                                index={index}
                                data={advertisementsData.items[item.id]}
                                currentSlideInViewport={isInViewport}
                                isMobile={true}
                            />
                        ))
                    )}

                    <Slider {...settings} beforeChange={this.onBeforeChange} afterChange={this.onAfterChange}>
                        {sliderItems.map((item, index) => {
                            const { id, type } = item
                            const isCurrentSlide = index === currSlide
                            
                            // for ken burns effect:
                            oddSlide = !oddSlide;
                            if (index+1 === itemsLength) oddSlide = false; // last slide has to be "even" to prevent "jump" bug


                            return <SliderBasicItemSwitch
                                key={index}
                                isMobile={isMobile}
                                index={index}
                                id={id}
                                filterValue={filterValue}
                                filterType={filterType}   
                                type={type}
                                showAvailableIn={showAvailableIn}
                                sliderType={sliderType}
                                isCurrentSlide={isCurrentSlide}
                                oddSlide={oddSlide}
                                kenBurnsToggle={kenBurnsToggles[index]}
                                isJustOneItem={isJustOneItem}
                                autoplaySpeed={settings.autoplaySpeed}
                                className = {scrollToPosition}
                                sliderTitle={sliderTitle}
                                moviesData={moviesData}
                                adsData={adsData}
                                canParallax={canParallax}
                                advertisementsData={advertisementsData}
                                weischerAdsData={weischerAdsData}
                                backgroundVisualsSettings={backgroundVisualsSettings}
                                theme={theme}
                                translation={translation}
                                isConnectedFast={isConnectedFast}
                                isInViewport={isInViewport}
                                eventOrigins={eventOrigins}
                                onClickSlideItem={!isChanging ? onClickSlideItem : () => {}}
                            />
                        })}
                    </Slider>

                    {hasWeischerItems && advertisementsItems.map((item, index) => (
                        <SliderBasicItemAdvertisement
                            key={item.id}
                            index={index}
                            data={advertisementsData.items[item.id]}
                            currentSlideInViewport={isInViewport}
                            isMobile={true}
                        />
                    ))}
                </>}
            </div>
        )
    }
}

export default withIsInViewport(Slide)